import React from 'react';
import PropTypes from 'prop-types';

import { Grid,Cell,LinearProgress } from 'react-md';

import '../../css/quizProgressBar.css'

const QuizProgressBar = function(props) {
    let totalTimeSeconds    =   (props.totalTime*60);
    let timeLeft            =   totalTimeSeconds    -   props.elapsedTime;
    let minutesLeft     =   Math.trunc(timeLeft/60);
    let secondsLeft     =   (timeLeft%60);
    let progressBarVal  =   (props.completedQuestions/props.totalQuestions)*100;

    let timerStyle   =   {'display':'none'}
    if(props.showTimer)
    {
        timerStyle = {'display':'block'}
    }
    return(
        <Grid className='quiz-progress'>
            <Cell  size={12} phoneSize={4} tabletSize={8} style={timerStyle} >
                Test closes in <strong>{minutesLeft}:{secondsLeft}</strong> minutes
            </Cell>
            <Cell  size={6} phoneSize={2} tabletSize={4}>
                <strong>Progress</strong>
            </Cell>
            <Cell  size={6} phoneSize={2} tabletSize={4} id='completedStatusDiv'>
                <strong>Completed</strong> {props.completedQuestions}/{props.totalQuestions}
            </Cell>
            <Cell  size={12} phoneSize={4} tabletSize={8}>
                <LinearProgress id='quizProgressBar' className='quiz-progress-bar' value={progressBarVal}></LinearProgress>
            </Cell>
        </Grid>
    );
}

QuizProgressBar.propTypes = {
                                totalTime:PropTypes.number.isRequired,
                                elapsedTime: PropTypes.number.isRequired,
                                totalQuestions: PropTypes.number.isRequired,
                                completedQuestions:PropTypes.number.isRequired,
                                showTimer:PropTypes.bool.isRequired
                            };


export default QuizProgressBar;
